<template>
  <div>
    <el-dialog
      title="温馨提示"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      @close="$router.push('/home')"
    >
      <div style="text-align: center">
        <div>企业贷款，请联系客服经理</div>
        <img src="../../assets/img/qr.png" alt="" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="(dialogVisible = false), $router.push('/home')"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  mounted() {
    this.stop();
  },
  methods: {
    stop() {
      // this.$confirm(
      //   "该功能须另行签署委托协议方可开通，详情请<a title='邮箱地址：769319435.qq.com' href='mailto:769319435.qq.com'> 联络我们</a>！<p>邮箱地址：769319435.qq.com</p>",
      //   "提示",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     dangerouslyUseHTMLString: true,
      //     showCancelButton: false,
      //     type: "warning",
      //     center: true,
      //   }
      // )
      //   .then(() => {
      //     this.$router.push("/home");
      //   })
      //   .catch(() => {
      //     this.$router.push("/home");
      //   });
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
</style>